import React, { Component, } from 'react';
import styled from 'styled-components';
import { func, object, bool, } from 'prop-types';
import { connect, } from 'react-redux';
import { Redirect, } from 'react-router-dom';

import Input from '../../legacy-tv-ui/Input';
import Widget from '../../legacy-tv-ui/Widget';
import Grid from '@material-ui/core/Grid';
import { USERS_MAP, } from '../../constant';
import { authUser, } from './actions';
import fetchLogin from './actions/login';
import Button from '../../components/Button';

const InputContainer = styled.div`
  width: 200px;
  margin: 0 auto;
`;
const MainContainer = styled.div`
  position: fixed;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
  z-index: 1;
`;
const BackButtonContainer = styled.span`
  position: absolute;
  cursor: pointer;
  left: 0;
  top: -56px;
  padding: 4px 15px;
  border: 1px solid #ccc;
  border-radius: 2px;
`;

export class Login extends Component {
  static propTypes = {
    fetchLogin: func.isRequired,
    match: object.isRequired,
    history: object.isRequired,
    isAuth: bool,
  }
  static defaultProps = {
    isAuth: false,
  }
  constructor(props) {
    super(props);
    this.state = {
      password: '',
    };
  }
  componentDidMount() {
    const input = document.getElementById('ps-input');
    input && input.focus();
  }
  updateInput = (key, value) => {
    this.setState({
      [key]: value,
    });
  }
  handleSubmit = (e) => {
    e.preventDefault();
    const {
      projectId,
    } = this.props.match.params;

    this.props.fetchLogin(projectId, this.state.password);
    // if (USERS[this.props.match.params.projectId] === this.state.password) {
    //   this.props.authUser();
    // }
  }
  render() {
    const {
      isAuth,
      match,
    } = this.props;
    const {
      projectId,
    } = match.params;
    if (isAuth) {
      return (<Redirect
        to={`/${projectId}/date-select`}
      />);
    }
    return (
      <MainContainer>
        <Grid container>
          <Grid item xs={12} sm={3} lg={4} />
          <Grid item xs={12} sm={6} lg={4}>
            <Widget
              title={`使用者: ${USERS_MAP[projectId].companyName}`}
              style={
                {
                  marginTop: 100,
                  textAlign: 'center',
                  position: 'relative',
                }
              }
            >
              <BackButtonContainer
                onClick={() => this.props.history.push('/')}
              >
                返回
              </BackButtonContainer>
              <form onSubmit={this.handleSubmit}>
                <InputContainer>
                  <Input
                    id="ps-input"
                    style={{ marginBottom: 10, }}
                    placeholder="密碼"
                    type="password"
                    value={this.state.password}
                    onChange={e => this.updateInput('password', e.target.value)}
                  />
                </InputContainer>
                {
                  this.state.password &&
                  <Button type="submit">
                    送出
                  </Button>
                }
              </form>
            </Widget>
          </Grid>
        </Grid>
      </MainContainer>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

const dispatchObj = {
  authUser,
  fetchLogin,
};

export default connect(mapStateToProps, dispatchObj)(Login);



// WEBPACK FOOTER //
// ./src/scenes/Login/index.js